// extracted by mini-css-extract-plugin
module.exports = {"appDownloadImage":"_3dF11","appBadgeWhiteSmall":"_2nXd4","appBadgeWhite":"HFCRy","appBadgeBlack":"_3jrEY","appTeaser":"_1lQBz"};